<template>
  <v-sheet elevation="3">
    <v-form>
      <v-container fluid>
        <v-layout row wrap justify-center>
          <h3 class="mb-4 mt-1 title">Portail clients</h3>
          <v-flex xs12>
            <v-text-field
              label="E-mail"
              outline
              v-model="login"
              name="login"
              :error-messages="errors.collect('login')"
              v-validate="'required|email'"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Mot de passe"
              outline
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'visibility_off' : 'visibility'"
              @click:append="showPassword = !showPassword"
              v-model="password"
              name="password"
              :error-messages="errors.collect('password')"
              v-validate="'required|min:8'"
            ></v-text-field>

            <div class="ml-1 mb-2">
              <a @click="forgotPassword">Mot de passe oublié ?</a>
            </div>
          </v-flex>
          <v-flex xs6 class="d-flex justify-center">
            <v-btn flat @click="$router.push('/signup')" color="primary"
              >Je m'inscris</v-btn
            >
          </v-flex>
          <v-flex xs6 class="d-flex d-flex-initial justify-center">
            <v-btn outline @click="submit" color="accent">Connexion</v-btn>
          </v-flex>
          <v-snackbar v-model="showError" :bottom="true">
            {{ errorMessage }}
          </v-snackbar>
          <v-snackbar v-model="showForgotPasswordMsg" :bottom="true">
            Un lien pour le renouvellement vous a été envoyé par mail (sauf si
            nous n'avons pas trouvé votre compte).
          </v-snackbar>
        </v-layout>
      </v-container>
    </v-form>
  </v-sheet>
</template>

<script>
import { fetchHil } from "../utils";

export default {
  name: "LoginForm",
  data: function() {
    return {
      showPassword: false,
      login: "",
      password: "",
      showError: false,
      errorMessage: "",
      showForgotPasswordMsg: false
    };
  },
  methods: {
    async forgotPassword() {
      if (!(await this.$validator.validate("login"))) {
        return;
      }

      try {
        const resp = await fetchHil("/user/forgotPassword", {
          method: "POST",
          body: { email: this.login }
        });
        if (!resp.ok) {
          this.errorMessage = "Une erreur interne a eu lieu";
          this.showError = true;
        } else {
          this.showForgotPasswordMsg = true;
        }
      } catch (e) {
        this.errorMessage = "Une erreur interne a eu lieu";
        this.showError = true;
      }
    },

    async submit() {
      const { login, password } = this;
      if (!(await this.$validator.validateAll())) {
        return;
      }
      try {
        await this.$store.dispatch("login", { login, password });
        this.$emit("login");
      } catch (e) {
        if (e.message == 401) {
          this.errorMessage = "Identifiant ou mot de passe incorrect";
        } else {
          this.errorMessage = "Une erreur interne a eu lieu";
        }
        this.showError = true;
      }
    }
  }
};
</script>

<style scoped></style>
